import {
  PluginEquifaxConsumerCreditReportForm,
  PluginEquifaxConsumerCreditReportFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxConsumerCreditReportForm = (
  constructPost: ConstructPost,
  data: PluginEquifaxConsumerCreditReportForm,
): Promise<
  | NonPaginatedResponse<PluginEquifaxConsumerCreditReportFormResponse>
  | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEquifaxConsumerCreditReportFormResponse>
  >(`${PLUGIN_BASE_PATH}/equifax-consumer-credit-report-form`, { data });
